import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { DEFAULT_PAGE_SIZE, ListPagination } from '@/components/common/ListPagination'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'
import { serviceRecordsApi } from '@/api/service-records'
import { ServiceRecordTable } from '@/pages/customers/service-records/components/ServiceRecordTable'

interface SummaryDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  userId: number
  userName: string
  dateRange?: { start_date?: string; end_date?: string }
  scope?: string
  department_id?: number
}

export function SummaryDrawer({ open, onOpenChange, userId, userName, dateRange, scope, department_id }: SummaryDrawerProps) {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  useEffect(() => { setPage(1) }, [userId])
  const { data, isLoading } = useQuery({
    queryKey: ['service-records', 'summary', userId, page, pageSize, dateRange?.start_date, dateRange?.end_date, scope, department_id],
    queryFn: () => serviceRecordsApi.summary(userId, {
      page, page_size: pageSize,
      start_date: dateRange?.start_date, end_date: dateRange?.end_date,
      scope, department_id,
    }),
    enabled: open && userId > 0,
  })

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:w-[50vw] sm:max-w-none overflow-y-auto">
        <SheetHeader>
          <SheetTitle>{userName} 的服务记录</SheetTitle>
        </SheetHeader>
        <div className="mt-4 space-y-3">
          {isLoading ? (
            <Skeleton className="h-40 w-full" />
          ) : (
            <>
              <ServiceRecordTable records={data?.list ?? []} showActions={false} />
              <ListPagination
                total={data?.total ?? 0}
                page={page}
                pageSize={pageSize}
                onPageChange={setPage}
                onPageSizeChange={size => { setPageSize(size); setPage(1) }}
              />
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}
